import { ClientConfig } from "@/models/clientConfig";
import { defineStore } from "pinia";
import { ref } from "vue";
import { mainServices } from "@/services/mainServices";

export const useRequirementsStore = defineStore("requirements", () => {
  const requirementsData = ref({
    medicationRequirements: null,
    diagnosisRequirements: null,
    payerQuestions: null,
    stepTherapyRequirements: null,
    insurancePlanTypes: null,
  });
  const clientConfig = ref(null);

  async function refreshClientConfig(clientCompanyId) {
    clientConfig.value = null;
    const response = await mainServices.getClientConfig(clientCompanyId);
    clientConfig.value = new ClientConfig(response, clientCompanyId);
  }

  async function refreshCurrentUserClientConfig() {
    clientConfig.value = null;
    const response = await mainServices.getCurrentUserClientConfig();
    clientConfig.value = new ClientConfig(response, response.clientCompanyId);
  }

  return {
    requirementsData,
    clientConfig,
    refreshClientConfig,
    refreshCurrentUserClientConfig,
  };
});
